import { render, staticRenderFns } from "./PxSelectMultiple.vue?vue&type=template&id=932b8d9e&"
import script from "./PxSelectMultiple.vue?vue&type=script&lang=js&"
export * from "./PxSelectMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports